// extracted by mini-css-extract-plugin
export default {"searchDropdown":"SearchDropdown_searchDropdown","recentSearchesOverlay":"SearchDropdown_recentSearchesOverlay","searchDropdownHomePage":"SearchDropdown_searchDropdownHomePage"};